export const languageOptions = [
  {
    value: 'nan',
    label: '福建文',
  },
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'zh',
    label: '北方文 / 華文',
  },
];
